<template>
	<section class="contactContainer">
		<h2 class="titlePage">
			<strong>_</strong>
			Nous contacter
			<strong>_</strong>
		</h2>
		<div class="contactView">
			<form id="contactForm" method="post">
				<p class="headText">
					Vous souhaitez réserver un de nos gîtes ou vous souhaitez plus d'informations ?
					<br />Vous pouvez nous contacter via ce formulaire ou en nous appelant au 06 25 62 74 64.
				</p>

				<!-- <div class="flex"> -->
				<p>
					<label for="prenom">Votre prénom</label>
					<br />
					<input id="prenom" v-model="prenom" type="text" name="prenom" placeholder="Prénom" required />
				</p>
				<p>
					<label for="nom">Nom</label>
					<br />
					<input id="Nom" v-model="nom" type="text" name="nom" placeholder="Nom" required />
				</p>
				<!-- </div> -->
				<!-- <p>
          <label for="ville">Ville</label>
          <input id="ville" v-model="ville" type="text" name="ville" required />
        </p>
        <p>
          <label for="codePostal">Code Postal</label>
          <input
            id="codePostal"
            v-model="codePostal"
            type="text"
            name="codePostal"
            pattern="[0-9]{5}"
            oninvalid="this.setCustomValidity('Format attendu : 12345')"
            oninput="setCustomValidity('')"
            required
          />
        </p>-->
				<!-- <p>
          <label for="adresse">Adresse</label>
          <input id="adresse" v-model="adresse" type="text" name="adresse" required />
        </p>
        <p>
          <label for="departement">Département /région</label>
          <input id="departement" v-model="departement" type="text" name="departement" required />
        </p>
        <p>
          <label for="pays">Pays</label>
          <input id="pays" v-model="pays" type="text" name="pays" required />
        </p>-->

				<p>
					<label for="email">Votre e-mail</label>
					<br />

					<input
						id="email"
						pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
						v-model="email"
						type="text"
						name="email"
						oninvalid="this.setCustomValidity('Email invalide : vérifiez votre saisie')"
						oninput="setCustomValidity('')"
						placeholder="e-mail"
						required
					/>
				</p>

				<p>
					<label for="phone">Un téléphone</label>
					<br />
					<input
						id="phone"
						v-model="phone"
						type="text"
						name="phone"
						pattern="[0-9]{10}"
						oninvalid="this.setCustomValidity('Format attendu : 10 chiffres sans espace ex 0123456789 ')"
						oninput="setCustomValidity('')"
						placeholder="Téléphone au format 0123456789 "
						required
					/>
				</p>
				<p>
					<label for="objet">Objet</label>
					<br />
					<input id="objet" v-model="objet" type="text" name="objet" placeholder="Objet du message" required />
				</p>
				<!--fax indispensable ! ne pas supprimé  -->
				<p>
					<input
						type="checkbox"
						name="contact_me_by_fax_only"
						v-model="faxNumber"
						value="1"
						style="display:none !important"
						tabindex="-1"
						autocomplete="off"
					/>
				</p>

				<p>
					<label for="message">Votre message</label>
					<br />
					<textarea id="message" v-model="message" type="text" name="message" required></textarea>
				</p>

				<p>
					<label for="acceptConditionUse">
						<input id="acceptConditionUse" v-model="acceptConditionUse" type="checkbox" name="acceptConditionUse" required />
						Accepter les conditions d'utilisation
					</label>
				</p>

				<p>
					<label for="acceptCommercialUse">
						<input id="acceptCommercialUse" v-model="acceptCommercialUse" type="checkbox" name="acceptCommercialUse" />
						Accepter de recevoir des offres commerciales
					</label>
				</p>

				<p v-if="errors && errors.length" class="error" @click="errors = []">
					<b>Les champs suivant contiennent des erreurs que vous devez corriger pour valider ce formulaire :</b>
				</p>
				<ul>
					<li v-for="error in errors" :key="error">{{ error }}</li>
				</ul>
				<p v-if="success" class="success" @click="success = false">Votre e-mail a bien été envoyé</p>

				<p>
					<button type="button" @click="checkForm">Valider</button>
				</p>
			</form>

			<div>
				<iframe
					class="mapIframe"
					src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d184615.76004289163!2d0.8169994489746114!3d43.69763688299195!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xbe3c941ce3f95842!2sGITE%20D&#39;EN%20LEBE!5e0!3m2!1sfr!2sfr!4v1590479140827!5m2!1sfr!2sfr"
					frameborder="0"
					style="border:0;"
					allowfullscreen
					aria-hidden="false"
					tabindex="0"
				></iframe>
			</div>
		</div>

		<div class="commentVenir">
			<h3>Comment venir :</h3>
			<p>
				<b>Au coeur de la Gascogne, dans le département du Gers</b>
				<br />À 6 km de la gare sncf de Gimont <br />À 50 km de Toulouse <br />À 50 km de l'aéroport Toulouse-Blagnac
				<br />
			</p>
		</div>

		<section class="avion">
			<img src="@/assets/images/background/avion.jpg" alt="avion coucou au décolage" />
			<div>
				<h3>
					Vous pouvez maintenant rejoindre
					<br />le Gîte d'en Lébé par les airs !
				</h3>
				<p>
					<span>L’accès par les airs est aussi possible. Une piste privée est réservée pour l’aviation légère.</span>
					<br />
					<span>Si cela vous tente, veuillez nous contacter pour toutes les formalités administratives et de sécurité.</span>
				</p>
			</div>
		</section>
	</section>
</template>

<script>
export default {
	data: function() {
		return {
			errors: [],
			success: false,
			prenom: null,
			nom: null,
			ville: "",
			adresse: "",
			codePostal: "",
			departement: "",
			faxNumber: null,
			pays: "",
			email: null,
			phone: null,
			objet: null,
			message: null,
			ip: "string",
			browser: "string",
			acceptConditionUse: false,
			acceptCommercialUse: false,
			timer: null,
			time: 0,
		};
	},
	mounted: function() {
		this.getUserInfos();
		// this.timerFunc()
		this.timer = window.setInterval(() => {
			this.time++;
		}, 1000);
	},
	beforeDestroy: function() {
		if (this.timer) {
			window.clearInterval(this.timer);
			this.timer = null;
		}
	},
	watch: {},
	methods: {
		checkForm: function(e) {
			// if required fields are set
			if (this.prenom && this.nom && this.email && this.message && this.objet && this.acceptConditionUse) {
				let value = this.prepareStringToSend();
				this.secureTheMsg(value);
				// this.resetForm();
				return true;
			} else if (this.faxNumber || this.time < 12) {
				// this.resetForm();
				this.errors = [];
				this.success = true;
			} else {
				this.errors = [];

				if (!this.prenom) {
					this.errors.push("Prénom requis.");
				}
				if (!this.nom) {
					this.errors.push("Nom requis.");
				}
				// if (!this.ville) {
				//   this.errors.push("Ville requise.");
				// }
				// if (!this.codePostal) {
				//   this.errors.push("code postal requise.");
				// }
				// if (!this.adresse) {
				//   this.errors.push("adresse requise.");
				// }
				if (!this.email) {
					this.errors.push("Email requis.");
				}
				if (!this.objet) {
					this.errors.push("Objet requis.");
				}
				if (!this.message) {
					this.errors.push("Message requis.");
				}
				if (!this.acceptConditionUse) {
					this.errors.push("Vous devez accepter les conditions.");
				}
				e.preventDefault();
			}
		},

		prepareStringToSend() {
			if (this.acceptCommercialUse) {
				this.acceptCommercialUse = 1;
			} else this.acceptCommercialUse = 0;

			if (this.acceptConditionUse) {
				this.acceptConditionUse = 1;
			} else this.acceptConditionUse = 0;

			let myStr =
				this.$store.state.globalData.name +
				"|" +
				this.nom.replace(/\|/g, "_") +
				"|" +
				this.prenom.replace(/\|/g, "_") +
				"|" +
				this.phone.replace(/\|/g, "_") +
				"|" +
				this.email.replace(/\|/g, "_") +
				"|" +
				this.adresse.replace(/\|/g, "_") +
				"|" +
				this.ville.replace(/\|/g, "_") +
				"|" +
				this.codePostal.replace(/\|/g, "_") +
				"|" +
				this.departement.replace(/\|/g, "_") +
				"|" +
				this.pays.replace(/\|/g, "_") +
				"|" +
				this.objet.replace(/\|/g, "_") +
				"|" +
				this.message.replace(/\|/g, "_") +
				"|" +
				this.acceptCommercialUse +
				"|" +
				this.acceptConditionUse +
				"|" +
				this.browser +
				"|" +
				this.ip +
				"|" +
				this.$store.state.globalData.siteId +
				"|";
			return myStr;
		},
		secureTheMsg(myStr) {
			fetch(process.env.VUE_APP_URL_CRYPTO, {
				method: "POST",
				// mode: "cors",
				headers: {
					"Content-Type": "application/json; charset=utf-8",
				},
				body: JSON.stringify({
					pKey: process.env.VUE_APP_GRAPH_APIKEY,
					pDatas: myStr,
				}),
			})
				.then(function(res) {
					return res.json();
				})
				.then((res) => {
					// console.log(res.d);
					if (res.d != "") {
						this.sendMessage(JSON.parse(res.d));
					}
				});
		},
		sendMessage(cryptedValue) {
			let body = JSON.stringify({
				pKey: process.env.VUE_APP_GRAPH_APIKEY,
				pType: "web-contact",
				pDatas: cryptedValue,
			});
			fetch(process.env.VUE_APP_URL_SENDMAIL, {
				method: "POST",
				// mode: "cors",
				headers: {
					"Content-Type": "application/json; charset=utf-8",
				},
				body: body,
			})
				.then(function(res) {
					return res.json();
				})
				.then(function(res) {
					// console.log(res.d)
					return res;
				});
			this.success = true;
		},
		resetForm() {
			this.prenom = "";
			this.nom = "";
			this.phone = "";
			this.email = "";
			this.adresse = "";
			this.codePostal = "";
			this.ville = "";
			this.departement = "";
			this.objet = "";
			this.message = "";
			this.pays = "";
			this.acceptCommercialUse = false;
			this.acceptConditionUse = false;
		},

		getUserInfos() {
			fetch(process.env.VUE_APP_URL_USERDATA)
				.then((res) => {
					return res.json();
				})
				.then((res) => {
					this.ip = res.IP;
					this.browser = res.BROWSER;
				});
		},
	},
};
</script>

<style scoped>
input,
textarea {
	outline: none;
	margin: 10px;
}

textarea:focus:invalid,
input:focus:invalid {
	border: 1px solid tomato;
	box-shadow: 0 0 5px tomato;
}

textarea:focus:valid,
input:focus:valid {
	border: 1px solid var(--dark-color);
	box-shadow: 0 0 5px var(--dark-color);
}

.success {
	background: var(--dark-color);
	padding: 4px;
	text-align: center;
}

.error {
	color: tomato;
}

.contactView {
	display: flex;
}
.contactView > * {
	width: 50%;
}
.contactView iframe {
	width: 100%;
	height: 100%;
}
.contactContainer {
	margin-bottom: 1rem;
}
.contactContainer h2 {
	color: var(--dark-color);
	margin: 2rem 0;
}

.contactView form {
	padding: 1rem;
}
.contactView label {
	margin-left: 20%;
}
.contactView textarea,
.contactView input {
	border: 1px var(--main-color) solid;
	border-radius: 5px;
	height: 40px;
	width: 60%;
	margin: 0;
	margin-top: 8px;
	padding-left: 1%;
	margin-left: 20%;
	font-family: inherit;
	font-size: inherit;
}
.contactView textarea {
	height: 100px;
}

.contactView input[type="checkbox"] {
	height: unset;
	border: 1px var(--main-color) solid;
	border-radius: 5px;
	width: unset;
	margin: 0;
	margin-top: unset;
	margin-left: unset;
}

.contactView button {
	float: right;
	margin-right: 5%;
	padding: 1rem 1.5rem;
	background: var(--main-color);
	border: 1px var(--main-color) solid;
	font-size: 1rem;
	text-transform: uppercase;
	color: white;
	transition: 0.3s all ease;
}
.contactView button:hover {
	background-color: transparent;
	color: var(--main-color);
	transition: 0.3s all ease;
}

.headText {
	margin-left: 10%;
	font-size: 1.2rem;
	margin-bottom: 2rem;
}
.commentVenir {
	margin: 0 10% 0 50%;
}
.commentVenir h3 {
	text-transform: uppercase;
	color: var(--dark-color);
	margin-bottom: 0;
}
button {
	cursor: pointer;
}
@media all and (max-width: 1300px) {
	.contactView textarea,
	.contactView input {
		margin-left: 10%;
		width: 80%;
	}
	.contactView label {
		margin-left: 10%;
	}
}

@media all and (max-width: 1000px) {
	.contactView {
		flex-direction: column;
	}
	.contactView > * {
		width: 100%;
	}
	.contactView iframe {
		height: 70vh;
		margin-top: 1rem;
	}
	.contactView form {
		padding: 0;
	}
	/* form p {
    max-width: 90%;
  } */
	.headText {
		margin-left: 2%;
	}
	.commentVenir {
		margin: 0 5%;
	}
}
</style>
